<div class="container">
  <div class="text-wrapper">
    <mat-form-field appearance="fill">
      <mat-label>טקסט להודעה</mat-label>
      <textarea matInput (input)="onTextAreaChange($event)" autocomplete="off" spellcheck="false"></textarea>
    </mat-form-field>
  </div>
</div>
